import { imgPathWithTransforms, imgSrcSetFull } from '../../../logged_out_homepage/utils/image';
import { XLRG_IMAGE, DPR_1 } from '../../../logged_out_homepage/utils/constants';

const XLARGE_WIDTH = 1400;

const fallbackImgSrc = 'd19dc81184b5d21606d7829c012917bc-1679583178577/bg-find-expert-1400-x1.png';
const fallbackImgSrcRetina = 'd19dc81184b5d21606d7829c012917bc-1679583178581/bg-find-expert-1400-x2.png';

/* image is not shown on medium or small screens, so need for the small/medium sizes */
export const pictureData = [
    {
        srcSet: imgSrcSetFull({
            width: XLARGE_WIDTH,
            img: fallbackImgSrc,
            retinaImg: fallbackImgSrcRetina,
        }),
        media: XLRG_IMAGE,
    },
];

export const imgSrc = imgPathWithTransforms({ width: XLARGE_WIDTH, dpr: DPR_1, img: fallbackImgSrc });
